import React, { useEffect, useState, useRef } from "react";
import styles from "./AudioPopUp.module.css";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

/*** icon import ***/
import { FaRegCirclePlay as PlayIcon } from "react-icons/fa6";
import { FaCirclePause as PauseIcon } from "react-icons/fa6";
import { FaChevronCircleRight } from "react-icons/fa";
// import { LuArrowLeftCircle } from "react-icons/lu";
/** Play Next Icon */
import { MdOutlineSkipPrevious as PreviousIcon } from "react-icons/md";
import { MdOutlineSkipNext as NextIcon } from "react-icons/md";

import ProgressBar from "../reusable/player/ProgressBar";
import { useAudio } from "../../context/AudioContext";
import Rabbit from "rabbit-node/lib/rabbit";

const AudioPopUp = () => {
  const audioContext = useAudio();
  const [isVisible, setIsVisible] = useState(true);
  const [leftButton, setleftButton] = useState(false);

  /** this useState is use to get stop position of rotation image **/
  const [startPosition, setStartPosition] = useState(0);
  const [stopPosition, setStopPosition] = useState(0);
  const containerRef = useRef();

  const navigate = useNavigate();

  const containerVariants = {
    visible: { opacity: 1, x: 0 },
    hidden: { opacity: 0, x: "120%" },
  };

  const iconVariants = {
    visible: { opacity: 1 },
    hidden: { opacity: 0 },
  };

  const handleClose = () => {
    setIsVisible(false);
    setleftButton(true);
  };

  const handleOpen = () => {
    setIsVisible(true);
    setleftButton(false);
  };

  const handleRedirectToMusic = () => {
    navigate(audioContext.audioData.route);
  };

  // useEffect(() => {
  //   // Get the current rotation angle
  //   if (!audioContext.isPopUpRemove) {
  //     const computedStyle = getComputedStyle(containerRef.current);
  //     const transform =
  //       computedStyle.transform || computedStyle.webkitTransform;
  //     const matrix = new DOMMatrix(transform);
  //     let currentRotation = Math.atan2(matrix.b, matrix.a) * (180 / Math.PI);

  //     // if(currentRotation < 0) {
  //     //   let remaintAmount = currentRotation + 180;
  //     //   currentRotation = 180 + remaintAmount;
  //     // }

  //     setStopPosition(currentRotation);
  //   }
  // }, [audioContext.play, audioContext.isPopUpRemove]);

  return (
    <div className={audioContext.isPopUpRemove && 'hidden'}>
      {/* {
    audioContext.isPopUpRemove && ( */}
          <motion.div
            key={audioContext.audioData.audio_id}
            className={`rounded-lg fixed z-20 bg-slate-600 w-full h-23 justify-center ${styles.bottom} flex items-center`}
            variants={containerVariants}
            initial={isVisible ? "visible" : "hidden"}
            animate={isVisible ? "visible" : "hidden"}
            transition={{ duration: 0.5, ease: "easeOut" }}
          >
            <div className="w-1/3 flex" onClick={handleRedirectToMusic}>
                <img
                  src={audioContext.audioData.image}
                  alt={`Image`}
                  className={`rounded-full w-12 h-12 inline-block m-3 ${styles.circleImage}`}
                  width={40}
                  height={40}
                />
            </div>
            <div className="w-1/3 inline-block my-auto">
                <span className="block text-sm truncate">
                  {Rabbit.zg2uni(audioContext.audioData.title)}
                </span>
                <span className="block text-xs truncate">
                  {Rabbit.zg2uni(audioContext.audioData.reader)}
                </span>
              </div>
            <div className="w-1/3 flex justify-center py-2 rounded-full">
              <button
                onClick={audioContext.toggleAudio}
                type="button"
                className="m-auto w-9 rounded-full text-white shadow-sm"
              >
                {!audioContext.audioPlay ? (
                  <PlayIcon
                    className="h-10 w-10 text-yellow-300"
                    aria-hidden="true"
                  />
                ) : (
                  <PauseIcon
                    className="h-10 w-10 text-yellow-300"
                    aria-hidden="true"
                  />
                )}
              </button>
            </div>

            <span
              className="absolute top-[-10px] right-0"
              onClick={handleClose}
            >
              <FaChevronCircleRight />
            </span>
          </motion.div>

          <motion.div
            className={`absolute top-[-50px] right-2 cursor-pointer z-20 h-23  `}
            variants={iconVariants}
            initial="hidden"
            animate={leftButton ? "visible" : "hidden"}
            transition={{ duration: 0.5, ease: "easeOut" }}
            onClick={handleOpen}
          >
            {/* <LuArrowLeftCircle /> */}
          </motion.div>
        </div>
  );
};

export default AudioPopUp;
